import React from "react";

import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as SlotsPropertiesActions from "../../../store/actions/Slots";
import BulkUploadFile from "../../BulkUploadFile";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const FileUploadModal = ({ getUploadUrl }) => {
  return (
    <SlotCapacityUpdate>
      <BulkUploadFile
        instructions={instructions}
        btnDataTestID="slotsUpload"
        uploadUrl="/driver-shift/slot/bulk-update-capacity/ack"
        sampleURL="/sample/bulk_upload_slot_capacity.csv"
        id="bulkUploadSlotPropertiesModal"
        sendExtraAck={true}
        keyName="callback_key"
        heading="Slot Capacity Update"
        getUploadUrl={getUploadUrl}
      />
    </SlotCapacityUpdate>
  );
};

const SlotCapacityUpdate = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    getUploadUrl: bindActionCreators(
      SlotsPropertiesActions.getUploadUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(FileUploadModal);
